import {Component} from '@angular/core';
import {FormControl, NonNullableFormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ButtonDirective} from 'primeng/button';
import {InputTextModule} from 'primeng/inputtext';
import {Ripple} from 'primeng/ripple';
import {first} from 'rxjs';
import {BrokerProfileService} from '../../../services/broker-profile/broker-profile.service';
import {BTN_LOADING_ANIMATION_TIME} from '../../../utils/utility-constants';
import {AuthBackgroundComponent} from '../auth-background/auth-background.component';

@UntilDestroy()
@Component({
  selector: 'em-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  imports: [ReactiveFormsModule, ButtonDirective, AuthBackgroundComponent, InputTextModule, Ripple],
})
export class ForgotPasswordPageComponent {
  isSuccess = false;
  isButtonLoading = false;
  error = false;
  readonly control: FormControl<string>;

  constructor(
    private readonly router: Router,
    private readonly profileService: BrokerProfileService,
    private readonly fb: NonNullableFormBuilder,
  ) {
    this.control = this.fb.control('', Validators.required);

    this.control.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.error = false;
      this.isSuccess = false;
    });
  }

  goToLoginPage(): void {
    this.router.navigate(['/', 'auth']);
  }

  submit(): void {
    this.isButtonLoading = true;

    this.profileService
      .initiatePasswordReset(this.control.value)
      .pipe(first())
      .subscribe({
        next: () => {
          setTimeout(() => {
            this.isSuccess = true;
            this.isButtonLoading = false;
          }, BTN_LOADING_ANIMATION_TIME);
        },
        error: () => {
          setTimeout(() => {
            this.error = true;
            this.isButtonLoading = false;
          }, BTN_LOADING_ANIMATION_TIME);
        },
      });
  }
}
